import { scheduledSessionsDraftAtom } from '@/features/uploadSessionSchedule/atoms';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

/**
 * Hook to warn users before leaving the page if they have unsaved draft sessions
 */
export const useBeforeUnloadWarning = () => {
  const draftSessions = useAtomValue(scheduledSessionsDraftAtom);

  useEffect(() => {
    if (draftSessions.length === 0) {
      return;
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Modern browsers ignore custom messages and show their own
      e.preventDefault();
      e.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [draftSessions.length]);
};
